import { render, staticRenderFns } from "./dependentFeeItem.vue?vue&type=template&id=ad2f59fa&scoped=true&"
import script from "./dependentFeeItem.vue?vue&type=script&lang=tsx&"
export * from "./dependentFeeItem.vue?vue&type=script&lang=tsx&"
import style0 from "./dependentFeeItem.vue?vue&type=style&index=0&id=ad2f59fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2f59fa",
  null
  
)

export default component.exports